// extracted by mini-css-extract-plugin
export var downArrow = "_7r-0";
export var infoTooltipIcon = "_7r-3";
export var label = "_7r-1";
export var optionCard = "_7r-4";
export var upArrow = "_7r-2";